module.exports = __webpack_public_path__ + "static/media/black chart.1924311a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Problems/img/black chart.png
// module id = 266
// module chunks = 0